import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/i18n/language';
import { FfCabinetHeadComponent } from '../../freight-forwarder/cabinet-head/cabinet-head.component';

/**
 * «Сделки по сертификации» — заявки на сертификаты и декларации соответствия.
 * На сервере таких сделок пока нет (см. ТЗ), поэтому раздел объясняет, что здесь появится,
 * и ведёт к расчётам, где уже есть проверка разрешительных документов.
 */
@Component({
  selector: 'app-co-certification',
  standalone: true,
  imports: [CommonModule, RouterModule, FfCabinetHeadComponent],
  templateUrl: './co-certification.component.html',
  styleUrl: './co-certification.component.scss'
})
export class CoCertificationComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.languageService.getTranslations().subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  t(key: string, fallback: string): string {
    const value = this.languageService.translate(key);
    return value && value !== key ? value : fallback;
  }
}
